import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import _ from "lodash";
import Header from "../../../components/Header";
import Firebase from "../../../firebasehelper";
import { subsiteTexts as defaultText } from "../constants/default";
import "./index.css";

const TextArray = React.memo(({ subsiteTexts, onSave }) => {
  const [texts, setTexts] = useState([]);
  const [editable, setEditable] = useState([false, false, false]);
  useEffect(() => {
    setTexts(subsiteTexts);
  }, [subsiteTexts]);
  const handleChange =
    (index) =>
    ({ target }) => {
      const newTexts = _.cloneDeep(texts);
      newTexts[index].text = target.value;
      setTexts(newTexts);
    };
  const handleClick = (index) => () => {
    const newEditable = [...editable];
    newEditable[index] = !editable[index];
    setEditable(newEditable);
    if (editable[index]) {
      onSave(texts);
    }
  };
  return texts.map((item, index) => (
    <div className="line-div mb-3">
      <textarea
        type="text"
        style={{ fontSize: item.fontSize, fontWeight: item.fontWeight }}
        disabled={!editable[index]}
        onChange={handleChange(index)}
        value={item.text}
      />
      <button
        className={`btn ${editable[index] ? "btn-green" : "btn-default"} ml-2`}
        onClick={handleClick(index)}
      >
        {editable[index] ? "Save" : "Edit"}
      </button>
    </div>
  ));
});

const SubSite = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [subsiteTexts, setSubsiteTexts] = useState(defaultText);
  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      setLoading(true);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          setBrandData(brand_data);
          setLoading(false);
          const { taskersubsite } = brand_data;
          if (taskersubsite && taskersubsite.length > 0)
            setSubsiteTexts(taskersubsite);
        }
      });
    }
  }, [location]);

  const handleSave = (texts) => {
    const { brand } = location.state;
    Firebase.updateBrandDataById(brand, {
      taskersubsite: texts,
    });
  };

  return (
    <div id="page-container" className="ticket-type-container">
      <Header
        username={username}
        role={role}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand}
      />
      <main id="main-container">
        {loading && (
          <div className="loading">
            <i className="fa fa-4x fa-sync fa-spin text-muted" />
          </div>
        )}
        {!loading && (
          <div className="subsite-container mt-5">
            <TextArray subsiteTexts={subsiteTexts} onSave={handleSave} />
          </div>
        )}
      </main>
    </div>
  );
};

export default SubSite;



// WEBPACK FOOTER //
// ./src/screens/Tasks/SubSite/index.js